$(document).ready(function () {
    class CountdownTimer {
      constructor(initialTimeStr, $element, storageKey = null) {
        const [minutes, seconds] = initialTimeStr.split(":").map(Number);
  
        this.minutes = storageKey && sessionStorage.getItem(storageKey + "minutes")
          ? parseInt(sessionStorage.getItem(storageKey + "minutes"))
          : minutes;
  
        this.seconds = storageKey && sessionStorage.getItem(storageKey + "seconds")
          ? parseInt(sessionStorage.getItem(storageKey + "seconds"))
          : seconds;
  
        this.storageKey = storageKey;
        this.$element = $element;
        this.timer = null;
      }
  
      start() {
        const updateDisplay = () => {
          this.$element.text(`${this.minutes}:${padZero(this.seconds)}`);
        };
  
        const tick = () => this.start();
  
        this.seconds--;
  
        if (this.seconds < 0) {
          if (this.minutes > 0) {
            this.seconds = 59;
            this.minutes--;
            updateDisplay();
  
            if (this.storageKey) {
              sessionStorage.setItem(this.storageKey + "minutes", this.minutes);
              sessionStorage.setItem(this.storageKey + "seconds", this.seconds);
            }
  
            this.timer = setTimeout(tick, 1000);
          } else {
            clearTimeout(this.timer);
          }
        } else {
          updateDisplay();
          if (this.storageKey) {
            sessionStorage.setItem(this.storageKey + "seconds", this.seconds);
          }
          this.timer = setTimeout(tick, 1000);
        }
      }
    }
  
    function padZero(num) {
      return num < 10 ? "0" + num : num;
    }
  
    const $timers = $('[class^="tpl-sys-timer"]');
    const timersList = [];
  
    // Инициализация таймеров
    $timers.each(function () {
      const storageKey = $(this).data("tpl-sys-timer-key");
      const initialTime = $(this).data("tpl-sys-timer-time");
  
      if (storageKey) {
        timersList.push(new CountdownTimer(initialTime, $(this), storageKey));
      } else {
        timersList.push(new CountdownTimer(initialTime, $(this)));
      }
    });
  
    // Запуск всех таймеров
    timersList.forEach((timer) => {
      timer.start();
    });
  
    // Выставляем ширину таймера в зависимости от размера шрифта
    $timers.each(function () {
      const fontSize = parseInt($(this).parent().css("font-size"));
      const width = 2.3 * fontSize;
      $(this).css("width", width);
    });
  });
  